import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

export const Button = styled.button`
  width: 100%;
  min-width: 240px;
  max-width: max-content;
  display: flex;
  align-items: center;
  gap: ${spacing[8]};
  background-color: ${color.common.transparent};
  border-color: ${color.common.transparent};
  outline: none;
  ${font('text', 'md', '400')}
  text-align: left;
  color: ${color.darkBlue[1000]};

  .check-box {
    width: 16px;
    min-width: 16px;
    height: 16px;
    min-height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${spacing[4]};
    border: 1px solid ${color.grey[300]};
    background-color: ${color.common.white};

    svg,
    use {
      display: none;
    }

    &.active {
      border: 1px solid ${color.blue[500]};
      background: ${color.blue[50]};

      svg,
      use {
        display: block;
      }
    }
  }
`;
